import React, {Component} from 'react';
import PropTypes from "prop-types";
import translate from "../../services/translation";

export default class FavouritePopup extends Component {

    static propTypes = {
        isFavouriteAdded: PropTypes.bool,
        favouriteLink: PropTypes.string
    };

    render() {
        const {isFavouriteAdded, favouriteLink} = this.props;

        return (
            <div className={'addFavouritePopup'} data-nezzo-favourite-popup="">
                <div className={'addFavouritePopup--text'}>
                    {isFavouriteAdded ?
                        <div>
                            <span>{translate('favourite.add.popup')}</span>
                            <a href={favouriteLink}>{translate('favourite.title')}</a>
                        </div>
                        :
                        <div>{translate('favourite.remove.popup')}</div>
                    }
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Favourites/FavouritePopup.js